<template>
  <div class="gr-main-container">
    <section class="mentions">
      <div class="uk-container">
        
      <h2>La réservation est terminée !</h2>
      <p>Si vous souhaitez vous procurer une balise, rendez-vous le 14 octobre, jour de la remise des dossards à Ravine Blanche sur le stand SFR muni obligatoirement de votre carte bancaire physique.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ChoixCoureur',
  props: {
    msg: String
  }
}
</script>
